import { addDays } from "date-fns";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import pako from "pako";
import { decompressjsondata } from "../actions/common";

export const predefinedRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
    placement: "left",
  },
  {
    label: "Yesterday",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: "left",
  },
  {
    label: "Last 7 Days",
    value: [addDays(new Date(), -7), new Date()],
    placement: "left",
  },
  {
    label: "Last 30 Days",
    value: [addDays(new Date(), -30), new Date()],
    placement: "left",
  },
];

export const uistyles = {
  footerStyles: {
    padding: "2px 5px",
    display: "flex",
    justifyContent: "space-between" /* To push buttons to left and right */,
    alignItems: "center",
    width: "100%" /* Ensure container takes full width */,
  },
  footerButtonStyle: {
    float: "right",
    marginRight: 10,
    marginTop: 2,
  },
  footerButtonStyleRight: {
    float: "right",
    marginRight: 0,
    marginTop: "-4px",
  },
};

export const apiRequest = async (
  url,
  method = "GET",
  data = null,
  headers = {},
  isencrypt = false,
  debug = false
) => {
  const searchParams = new URLSearchParams(window.location.search);
  const queryString = !!searchParams.get("debug");

  try {
    const defaultHeaders = {
      // "Content-Type": "application/json",
      ...headers, // Allow custom headers
    };

    const options = {
      method,
      headers: defaultHeaders,
    };
    if (data) {
      options.body =
        isencrypt && !queryString
          ? pako.gzip(JSON.stringify({ ...data, debug: queryString }))
          : JSON.stringify(data);
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      return response;
    }
    if (isencrypt && !queryString) {
      const responseDataBuffer = await response.arrayBuffer();
      let responseData = await decompressjsondata(responseDataBuffer);

      return responseData;
    }
    return await response.json();
  } catch (error) {
    console.error("API Request Error:", error);
    return error; // Propagate error to the calling function
  }
};

export function decryptconfigdata(configkey) {
  var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
  var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
  var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
    iv,
  });
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  return plaintext;
}

export function decrypt(findresponse, flg) {
  var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
  var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
  var res = flg ? findresponse.encdata : findresponse;
  var bytes = CryptoJS.AES.decrypt(res, key, {
    iv,
  });
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(plaintext);
}

export const openInNewWindow = (url) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

export const muviUserId = () => {
  var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
  var localdata = has_local_data
    ? decrypt(localStorage.getItem("encdata"), 0)
    : "";

  return localdata;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js